import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { getProjectMilestones } from "../../../Services/projectServices";
import { getFormattedDate } from "../../../Utils";
import { FaFolderOpen, FaLeaf } from "react-icons/fa6";
import { TOAST_MESSAGES } from "../constants";
import { FaTools } from "react-icons/fa";
import { MANAGE_MATERIALS } from "../../../routes";
import { useNavigate } from "react-router-dom";
const statusColors = {
  IN_PROGRESS: "bg-blue-500",
  COMPLETED: "bg-green-500",
  PENDING: "bg-gray-300",
};

export default function MilestonesTracker({
  setShowFiles,
  setMilestone,
  setIsHandover,
  setCurrentMilestoneStatus,
}) {
  const { projectId } = useParams();
  const [milestones, setMilestones] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const fetchMilestones = () => {
    setLoading(true);
    getProjectMilestones(projectId)
      .then((response) => {
        if (response.status === 200) {
          setMilestones(response?.data?.results);
        } else {
          toast.error(TOAST_MESSAGES.MILESTONE_FETCH_FAILED);
        }
      })
      .catch((error) => {
        toast.error(TOAST_MESSAGES.MILESTONE_FETCH_FAILED);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fileClick = (milestoneId, milestoneTitle, milestoneStatus) => {
    if (milestoneTitle === "Handover") {
      setIsHandover(true);
      setShowFiles(false);
    } else {
      setShowFiles(true);
      setIsHandover(false);
    }
    setMilestone(milestoneId);
    setCurrentMilestoneStatus(milestoneStatus);
  };

  React.useEffect(() => {
    fetchMilestones();
  }, []);

  return (
    <div className="bg-white ">
      <div className="flex flex-col gap-4 relative">
        <div className="absolute top-1 left-4 py-1 w-1  bg-gray-200 h-[95%]"></div>
        {milestones?.map((milestone) => (
          <div key={milestone.id} className="relative flex items-center ">
            <div className="flex-shrink-0">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-white z-10 ${
                  statusColors[milestone.status] || "bg-gray-300"
                }`}
              >
                {milestone?.order}
              </div>
            </div>

            <div className="ml-6 flex justify-between items-center w-full">
              <div>
                <h3 className="text-sm font-semibold flex gap-2">
                  {milestone.title + " "}
                  {milestone.completion_date && (
                    <span className="text-[13px] text-gray-400">
                      ({getFormattedDate(milestone.completion_date)})
                    </span>
                  )}
                </h3>
                <p className="text-sm text-gray-500 capitalize">
                  {milestone.status.replace("_", " ").toLowerCase()}
                </p>
              </div>

              {milestone.title === "Procurement" ? (
                <div
                  className="cursor-pointer text-primary "
                  onClick={() =>
                    navigate(MANAGE_MATERIALS.replace(":projectId", projectId))
                  }
                >
                  <FaTools size={16} />
                </div>
              ) : (
                <div
                  className="cursor-pointer text-yellow-500"
                  onClick={() => {
                    fileClick(milestone.id, milestone.title, milestone?.status);
                  }}
                >
                  <FaFolderOpen size={16} />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
